import React from 'react';
import {Form, Header, Divider, Grid, Icon, Radio} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

const OrganizationSearch = ({
  value,
  searchDUNS,
  searchUEI,
  searchName,
  searchEIN,
  searchAddress,
  sortSelection,
  sortRadio,
  handleSearchRadio,
  handleDUNSText,
  handleUEIText,
  handleNameText,
  handleEINText,
  handleAddressText,
  handleSortSelection,
  handleSortRadio,
  clearAllFilters,
  clearLocalStorage,
  dunsToUEIToggle,
}) => {
  return (
    <Form id="organization-search">
      <Grid doubling stackable reversed="mobile" padded="vertically">
        <Grid.Column width={12}>
          <Header as="h3">Search</Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Icon name="undo" color="blue" size="small" />
          <a
            id="clearSearch"
            className="table-link"
            onClick={() => {
              clearAllFilters();
              clearLocalStorage();
            }}
          >
            Clear
          </a>
        </Grid.Column>
        {dunsToUEIToggle && (
          <Grid.Row columns={2} className="search-options">
            <Grid.Column>
              <Radio
                id="ueiButton"
                for="ueiButton"
                label="UEI-EFT"
                name="radioGroup"
                value="uei"
                checked={value === 'uei'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
            <Grid.Column>
              <Radio
                id="dunsButton"
                for="dunsButton"
                label="DUNS#"
                name="radioGroup"
                value="duns"
                checked={value === 'duns'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        {!dunsToUEIToggle && (
          <Grid.Row columns={2} className="search-options">
            <Grid.Column>
              <Radio
                id="dunsButton"
                for="dunsButton"
                label="DUNS#"
                name="radioGroup"
                value="duns"
                checked={value === 'duns'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
            <Grid.Column>
              <Radio
                id="EIN#"
                for="EIN#"
                label="EIN#"
                name="radioGroup"
                value="ein"
                checked={value === 'ein'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        {dunsToUEIToggle && (
          <Grid.Row columns={2} className="search-options">
            <Grid.Column>
              <Radio
                id="EIN#"
                for="EIN#"
                label="EIN#"
                name="radioGroup"
                value="ein"
                checked={value === 'ein'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
            <Grid.Column>
              <Radio
                id="subOrgName"
                for="subOrgName"
                label="Suborganization name"
                name="radioGroup"
                value="suborgName"
                checked={value === 'suborgName'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        {!dunsToUEIToggle && (
          <Grid.Row columns={2} className="search-options">
            <Grid.Column>
              <Radio
                id="subOrgName"
                for="subOrgName"
                label="Suborganization name"
                name="radioGroup"
                value="suborgName"
                checked={value === 'suborgName'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
            <Grid.Column>
              <Radio
                id="subOrgAddress"
                for="subOrgAddress"
                label="Address"
                name="radioGroup"
                value="address"
                checked={value === 'address'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        {dunsToUEIToggle && (
          <Grid.Row columns={2} className="search-options">
            <Grid.Column>
              <Radio
                id="subOrgAddress"
                for="subOrgAddress"
                label="Address"
                name="radioGroup"
                value="address"
                checked={value === 'address'}
                onChange={handleSearchRadio}
              />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
      {dunsToUEIToggle && value === 'uei' ? (
        <TextBoxField
          title="Search UEI"
          name="uei"
          id="search-uei"
          placeholder="Enter UEI-EFT"
          value={searchUEI}
          handleChange={handleUEIText}
        />
      ) : value === 'duns' ? (
        <TextBoxField
          title="Search DUNS"
          name="duns"
          id="search-duns"
          placeholder="Enter DUNS#"
          value={searchDUNS}
          handleChange={handleDUNSText}
        />
      ) : value === 'suborgName' ? (
        <TextBoxField
          title="Search suborganization name"
          name="name"
          id="search-suborganizationName"
          placeholder="Enter suborganization name"
          value={searchName}
          handleChange={handleNameText}
        />
      ) : value === 'ein' ? (
        <TextBoxField
          title="Search EIN"
          name="ein"
          id="search-ein"
          placeholder="Enter EIN#"
          value={searchEIN}
          handleChange={handleEINText}
        />
      ) : value === 'address' ? (
        <TextBoxField
          title="Search address"
          name="address"
          id="search-address"
          placeholder="Enter address"
          value={searchAddress}
          handleChange={handleAddressText}
        />
      ) : null}
      <Divider section />
      <Header as="h3" className="filter-header">
        Sort
      </Header>
      <InlineSelect
        search
        selection
        label="Sort by"
        title="Sort"
        id="sortBy"
        name="sortBy"
        placeholder="Sort by"
        value={sortSelection}
        handleChange={handleSortSelection}
        options={
          dunsToUEIToggle
            ? [
                {
                  key: 'legalBusinessName',
                  value: 'legalBusinessName',
                  text: 'Suborganization name',
                },
                {key: 'uei', value: 'uei', text: 'UEI-EFT'},
                {key: 'dunsNumber', value: 'dunsNumber', text: 'DUNS'},
                {key: 'ein', value: 'ein', text: 'EIN'},
              ]
            : [
                {
                  key: 'legalBusinessName',
                  value: 'legalBusinessName',
                  text: 'Suborganization name',
                },
                {key: 'dunsNumber', value: 'dunsNumber', text: 'DUNS'},
                {key: 'ein', value: 'ein', text: 'EIN'},
              ]
        }
      />
      <Form.Field>
        <Radio
          label="Ascending"
          name="sortOrder"
          id="sortOrderAsc"
          value="asc"
          checked={sortRadio === 'asc'}
          onChange={handleSortRadio}
        />
      </Form.Field>
      <Form.Field>
        <Radio
          label="Descending"
          name="sortOrder"
          id="sortOrderDesc"
          value="desc"
          checked={sortRadio === 'desc'}
          onChange={handleSortRadio}
        />
      </Form.Field>
    </Form>
  );
};

export default OrganizationSearch;
